// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import toggleLeaseAgreement from "@guestsupply/App/Handlers/XNG/CartLeaseAgreement";
import { ButtonPresentationProps } from "@guestsupply/MobiusOverrides/Button/Props";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import { LoadingOverlay } from "@insite/mobius/index";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    toggleLeaseAgreement,
};

export interface LeaseAgreementModalStyles {
    contentWrapper?: InjectableCss;
    agreebuttonStyle?: ButtonPresentationProps;
    agreementModalStyle?: ModalPresentationProps;
    modalText?: InjectableCss;
}

export const leaseAgreementModalStyles: LeaseAgreementModalStyles = {};

interface LeaseAgreementModalProps {
    handleModaleClose: () => void;
    isModalOpen: boolean;
    extendedStyles?: LeaseAgreementModalStyles;
}

type Props = LeaseAgreementModalProps & ResolveThunks<typeof mapDispatchToProps>;

const LeaseAgreementModal = ({ handleModaleClose, isModalOpen, toggleLeaseAgreement, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeWithCss(leaseAgreementModalStyles, extendedStyles));
    const [isLoading, setIsLoading] = useState(false);

    const handleAgreeClick = () => {
        setIsLoading(true);
        toggleLeaseAgreement({
            gpLeaseAccepted: "true",
            onComplete: result => {
                setIsLoading(false);
                handleModaleClose();
            },
        });
    };

    return (
        <Modal
            sizeVariant="large"
            headline={translate("Lease Agreement")}
            handleClose={handleModaleClose}
            isOpen={isModalOpen}
            {...styles.agreementModalStyle}
        >
            <LoadingOverlay loading={isLoading}>
                <StyledWrapper>
                    <StyledWrapper {...styles.modalText}>
                        {siteMessage(
                            "GUEST_Cart_Lease_agreement_Modal_Text",
                            "This Lease will inure to the  benefit  of  and  be  binding  upon  respective  successors  and authorized  assigns  of  the  parties  hereto.  If  any  provision  of  this Lease  is  deemed  unenforceable,  invalid  or  illegal  by  a  court  of competent jurisdiction, then the validity of the remaining provisions will not be affected and the rights and obligations   of GP and End User will be construed and enforced as if the Lease did not contain the particular provision deemed invalid or illegal. End User will only place the Dispensers in its locations within the United States.",
                        )}
                    </StyledWrapper>
                    <StyledWrapper {...styles.contentWrapper}>
                        <Typography>
                            {translate("I'm confirming that I have read and agree to the lease agreament")}
                        </Typography>
                        <Button onClick={handleAgreeClick} aria-label="I AGREE" {...styles.agreebuttonStyle}>
                            {translate("I AGREE")}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </LoadingOverlay>
        </Modal>
    );
};

export default connect(null, mapDispatchToProps)(LeaseAgreementModal);
